import { FC } from "react";
import { Table, TableContainer, Paper } from "@mui/material";
import { CollectionsTableHeaders } from "./CollectionsTableHeaders";
import { CollectionsTablePagination } from "./CollectionsTablePagination";
import { CollectionsTableLoadingState } from "./CollectionsLoadingState";
import { CollectionsTableErrorState } from "./CollectionsErrorState";
import { CollectionsTableEmptyState } from "./CollectionsEmptyState";
import { CollectionsDataState } from "./CollectionsDataState";
import { useCollectionsContext } from "../hooks/useCollectionsContext";

export const CollectionsTable: FC = () => {
  const { collections, loading, loadingError, typeFilter } =
    useCollectionsContext();

  const renderTableContent = () => {
    if (loading) return <CollectionsTableLoadingState />;
    if (!loading && loadingError) return <CollectionsTableErrorState />;
    if (collections.length === 0) return <CollectionsTableEmptyState />;
    return <CollectionsDataState />;
  };

  return (
    <TableContainer component={Paper}>
      <Table key={typeFilter}>
        <CollectionsTableHeaders />
        {renderTableContent()}
      </Table>
      <CollectionsTablePagination />
    </TableContainer>
  );
};
